var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendSmsLater({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_942_25)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8739 5.90267C19.101 4.87029 17.8683 4.20215 16.4795 4.20215C14.1393 4.20215 12.2422 6.09928 12.2422 8.43946C12.2422 8.8537 12.3015 9.25405 12.4124 9.63235C12.9276 11.3917 14.5536 12.6768 16.4795 12.6768C18.8197 12.6768 20.7168 10.7796 20.7168 8.43946C20.7183 7.52485 20.4225 6.63454 19.8739 5.90267ZM17.0092 6.32081C17.0092 6.18033 16.9534 6.04561 16.854 5.94628C16.7547 5.84695 16.62 5.79114 16.4795 5.79114C16.339 5.79114 16.2043 5.84695 16.105 5.94628C16.0056 6.04561 15.9498 6.18033 15.9498 6.32081V8.43946C15.9498 8.73201 16.1871 8.96913 16.4795 8.96913H18.3334C18.4739 8.96913 18.6086 8.91333 18.7079 8.81399C18.8073 8.71466 18.8631 8.57994 18.8631 8.43946C18.8631 8.29899 18.8073 8.16427 18.7079 8.06494C18.6086 7.9656 18.4739 7.9098 18.3334 7.9098H17.0092V6.32081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1074 13.1771C13.5992 12.9222 13.1355 12.5872 12.734 12.1848C11.9222 11.3756 11.3962 10.3238 11.2356 9.18883L7.34078 13.0837L10.1589 18.5146C10.6523 19.4658 12.047 19.3559 12.3861 18.3392L14.1074 13.1771ZM7.11582 11.8105L6.59172 12.3346L1.16086 9.5165C0.209619 9.02308 0.319521 7.62839 1.3362 7.28934L15.6127 2.52891C16.2473 2.31714 16.8613 2.65116 17.103 3.17958C15.5479 2.99609 13.9272 3.50101 12.734 4.69423C11.922 5.50364 11.396 6.55563 11.2355 7.69083L7.11594 11.8104L7.11582 11.8105Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_942_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSmsLater);
export default __webpack_public_path__ + "static/media/send-sms-later.02dbb8ef409c8a2f1261238946021e59.svg";
export { ForwardRef as ReactComponent };